import { Route, Switch, useLocation } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useSmOrMdScreenMediaQuery } from "@/react/hooks/useMediaQuery";
import { ConversationPage } from "../pages/ConversationPage";
import { ConversationsListPage } from "../pages/ConversationsListPage";
import { ExplorePage } from "../pages/ExplorePage";
import { HelpPage } from "../pages/HelpPage";
import { HomePage } from "../pages/HomePage";
import { BugReportConfirmationView } from "./BugReportConfirmationView";
import { ConversationLayout } from "./ConversationLayout";
import { CreateConversationView } from "./CreateConversationView";
import { EventsListView } from "./EventsListView";
import { HelpWidgetContainer } from "./HelpWidgetContainer";
import { HelpWidgetMobileContainer } from "./HelpWidgetMobileContainer";
import { NewsListView } from "./NewsListView";
import { NewsView } from "./NewsView";
import { PostView } from "./PostView";
import { RecentLocationWrapper } from "./RecentLocationWrapper";

export const Routes = ({ onClose }: { onClose: () => void }) => {
  const location = useLocation();
  const isMobile = useSmOrMdScreenMediaQuery();

  const getPageName = () => {
    switch (location.pathname) {
      case "/":
        return t("help_widget.home_page.title");
      case "/conversations":
        return "Conversations";
      case "/help":
        return t("help_widget.help_page.title");
      case "/explore":
        return "Explore";
      default:
        return "";
    }
  };

  const Container = isMobile ? HelpWidgetMobileContainer : HelpWidgetContainer;

  return (
    <Container onClose={onClose} pageName={getPageName()}>
      <RecentLocationWrapper>
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/explore" component={ExplorePage} />

          <Route exact path="/help" component={HelpPage} />
          <Route exact path="/spaces/:spaceId/posts" component={HelpPage} />
          <Route exact path="/space_groups" component={HelpPage} />
          <Route
            exact
            path="/posts/:id"
            render={({ match }) => (
              <PostView id={match.params.id} key={match.params.id} />
            )}
          />

          <Route exact path="/news" component={NewsListView} />
          <Route exact path="/news/:id" component={NewsView} />

          <Route exact path="/events" component={EventsListView} />

          <Route
            exact
            path="/conversations"
            render={() => (
              <ConversationLayout>
                <ConversationsListPage />
              </ConversationLayout>
            )}
          />
          <Route
            exact
            path="/conversations/:id"
            render={({ match }) => (
              <ConversationLayout>
                <ConversationPage id={match.params.id} key={match.params.id} />
              </ConversationLayout>
            )}
          />
          <Route
            exact
            path="/conversations/:id/new_ticket"
            component={CreateConversationView}
          />
          <Route
            exact
            path="/message_confirmation/:id"
            component={BugReportConfirmationView}
          />
        </Switch>
      </RecentLocationWrapper>
    </Container>
  );
};
